<template>
  <div>
    <div id="particles-bg">
      <span v-if="bol == false">
        <particles-bg
          id="particles-bg"
          color="#f7941e"
          num="100"
          type="cobweb"
          :bg="true"
      /></span>
      <span v-if="bol == true">
        <particles-bg
          id="particles-bg"
          color="#f7941e"
          num="35"
          type="cobweb"
          :bg="true"
      /></span>
    </div>
    <div class="outer">
      <div class="container">
        <div class="center">
          <img id="logo" src="@/assets/nearcode_6.svg" />
          <div class="text col-sm-12">
            <h2>{{ this.contents.find(content => content.id_content === 170)?.title }}  <span class="profile">{{ words[currentWordIndex] }}</span>
            </h2>
            <p>
              {{ this.contents.find(content => content.id_content === 171)?.title }}
            </p>
          </div>
          <router-link to="/services"
            ><a class="btn" id="readMore">
            {{ this.contents.find(content => content.id_content === 172)?.title }}
            </a></router-link
          >
<!--          <span v-if="this.contents.length != 0">-->
<!--            <div v-for="content in contents" :key="content.title">-->
<!--              <img class="circle" src="../assets/circle.svg" alt="" />-->
<!--              <Content-->
<!--                :title="content.title"-->
<!--                :description="content.description"-->
<!--              ></Content>-->
<!--            </div>-->
<!--          </span>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ParticlesBg } from "particles-bg-vue";
import { mapGetters } from "vuex";
// import Content from "@/components/Content";

export default {
  name: "App",
  components: {
    ParticlesBg,
    // Content,
  },
  data: function() {
    return {
      bol: false,
      contents: [],
      contents2 : [],
      currentWordIndex : 0,
      words : []
    };
  },
  created() {
    this.width();
  },
  mounted() {
    this.getAllContent();

    setInterval(() => {
      this.currentWordIndex = (this.currentWordIndex + 1) % this.words.length;
    }, 2300);

  },
  methods: {
    width() {
      if (window.screen.width <= 1000) {
        this.bol = true;
      } else {
        this.bol = false;
      }
    },
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 1) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
        if (this.contents.length > 5) {
          for (let i = 5; i < this.contents.length; i++) {
            this.contents2.push(this.contents[i]);
          }
        }
        const ids = [177, 178, 179];

        this.words = this.contents
            .filter(c => ids.includes(c.id_content))
            .map(c => c.title);

        console.log(this.words);
      } catch (err) {
        console.log(err);
        this.$router.push({ name: "Error" });
      }
    },
  },
  computed: { ...mapGetters(["getContent"]) },
};
</script>

<style scoped>
#readMore {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  display: block;
  width: 130px;
  margin: 25px auto 0px auto;
  background-color: #f7941e;
  color: white;
  text-decoration: none;
}
#readMore :hover {
  color: white;
  background-color: #888888;
  text-decoration: none;
  transform: scale(1.05);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
a {
  text-decoration: none;
}
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.center {
  margin-left: auto;
  margin-right: auto;
  width: 900px;
}
#logo {
  padding: 50px 0px 0px 0px;
  width: 100%;
  margin: auto;
  display: block;
}
.text {
  padding: 40px 0px 10px 0px;
}
p {
  font-family: "Source Code Pro", monospace;
  font-size: 25px;
  color: rgb(87, 87, 87);
  text-align: center;
}
h2 {
  font-family: "Source Code Pro", monospace;
  font-size: 40px;
  color: rgb(87, 87, 87);
  text-align: center;
  padding: 5px;
}
h2 span::before {
  content: "";
  font-weight: bold;
  color: #f7941e;
  //animation: profile 7s infinite;
}
#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
.profile {
  color: #f7941e;
  font-weight: bold;
  animation: fadeWord 2.3s infinite;
}

@keyframes fadeWord {
  0% { opacity: 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
}

@keyframes test {
  0% {
    opacity: 0%;
  }
  100% {
    opacity: 100%;
  }
}

.text {
  animation: test 5s;
}
#social {
  display: none;
}
.circle {
  padding-top: 60px;
  padding-bottom: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 1000px) {
  .circle {
    padding: 40px 0px 40px 0px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .outer {
    display: table;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .container {
    display: table-cell;
    vertical-align: middle;
  }
  .center {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  #logo {
    width: 100%;
    margin: auto;
    display: block;
  }

  #social {
    display: flex;
  }
  .text h2 {
    font-size: 28px;
  }
  .text p {
    font-size: 20px;
  }
}
</style>
